<script setup lang="ts">
import { ref, computed } from 'vue';

import PartFooterNavigation from '@parts/part-footer-navigation.vue';
import PartTitleHead from '@parts/part-title-head.vue';
import SectionSettings from '@sections/section-settings.vue';
import FormRadioInput from '@form/form-radio-input.vue';
import ButtonPrimary from '@buttons/button-primary.vue';
import CoreLoader from '@core/core-loader.vue';
import mockData from '/misc/settigns/country';

import { useSettings } from '@composables/settings';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const {
	goToNext,
	goToBack,
	selection,
	currentGroup,
	activeIndex,
	checkCurrentPageAccess,
} = useSettings();

const fields = computed(() => {
	return {
		title: t('settingsCountry.select'),
		list: mockData.list,
		buttonNext: {
			title: t('common.buttons.continue'),
		},
		buttonBack: {
			title: t('common.buttons.back'),
		},
		loader: {
			default: t('common.loader.country'),
		}
	}
});

const isLoader = ref(true);

checkCurrentPageAccess();
</script>

<template>
	<main class="page page-country">
		<section-settings
			v-if="currentGroup"
		>
			<transition
				appear
				name="fade"
				style="--animation-delay: 0.1s"
			>
				<part-title-head
					v-if="fields.title"
					black left
					:title="fields.title"
					title-font="font-18-pro-medium"
					sub-title-font="font-regular"
					class="page-country__content"
				></part-title-head>
			</transition>

			<!--
				Для <transition> нужно задать продолжительность анимации: animation-delay.
				Через "--animation-count" передаем количество элементов в списке, для построения продолжительсности.
			-->
			<transition
				v-if='!isLoader'
				appear
				name="show-up-container-items"
				:style="`--animation-delay: 0.3s;
				--animation-item-delay: 0.2s;
				--animation-duration: 0.6s;
				--animation-count: ${fields?.list?.length || 0}`"
			>
				<ul
					v-if="fields.list"
					class="page-country__list"
				>
					<li
						v-for="(item, index) in fields.list" :key="index"
						class="page-country__list-item"
					>
						<form-radio-input
							:value="item.id"
							v-model="selection.country"
							dark
							class="page-country__list-field"
						>
							<template v-slot:default>
								{{ $t(`common.countries.${item.code}`) }}
							</template>
							<template v-slot:append>
								<img
									:src="item.image"
									alt=""
									class="page-country__list-flag"
								>
							</template>
						</form-radio-input>
					</li>
				</ul>
			</transition>
			<transition
				v-else
				appear
				name="fade"
			>
				<core-loader
					dark
					inline
					:title="fields.loader.default"
				/>
			</transition>

			<part-footer-navigation
				v-if="activeIndex + 1 !== currentGroup?.list?.length"
				class="page-country__footer"
			>
				<button-primary
					class="page-country__save"
					:disabled="selection.country === null"
					@click.native="goToNext"
				>
					{{ fields?.buttonNext?.title }}
				</button-primary>
			</part-footer-navigation>
			<button-primary
				v-else
				pink
				@click.native="goToBack"
				class="page-country__save"
			>
				{{ fields?.buttonBack?.title }}
			</button-primary>
		</section-settings>
	</main>
</template>

<style lang="scss">
.page-country {
	display: flex;
	flex-direction: column;
	flex: 1 1 auto;
	color: #2A2137;

	&__content {
		--title-gap: 1.6rem;
		margin-bottom: 2.4rem;
	}

	&__list {
		display: flex;
		flex-direction: column;
		gap: 0.8rem;
		margin-bottom: 2rem;
	}
	&__list-item {
		display: block;
	}
	&__list-flag {
		width: 3rem;
		border-radius: 50%;
	}

	&__save {
		width: 100%;
	}
}
</style>
